// import PropTypes from 'prop-types';
// // material
// import { Grid } from '@mui/material';
// import AuditListCard from './AuditListCard';
// import { AuditPlayer } from '../@dashboard/audit';
// import { useEffect, useState } from 'react';
// import InfiniteScroll from 'react-infinite-scroll-component';

// // ----------------------------------------------------------------------

// AuditList.propTypes = {
//   audits: PropTypes.array.isRequired,
//   loadMoreAudits: PropTypes.func.isRequired, // Expect a function to fetch more audits
// };

// export default function AuditList({
//   clientId,
//   audits,
//   loadMoreAudits,
//   updateToClient,
//   isEscalating,
//   ...other
// }) {
//   const agentType = localStorage.getItem('IsAgentBased');

//   const initValues = {
//     src: null,
//     isOpen: false,
//   };
//   const [player, setPlayer] = useState(initValues);
//   const [displayAudits, setDisplayAudits] = useState([]); // Audits to display
//   const [hasMore, setHasMore] = useState(true); // Controls infinite scroll

//   const ITEMS_PER_PAGE = 20;

//   console.log("displayAudits==========",displayAudits)
//   // Load the initial 20 audits on component mount
//   useEffect(() => {
//     console.log("================================================================",audits)
//     setDisplayAudits(audits.slice(0, ITEMS_PER_PAGE));
//   }, [audits]);

//   // Function to handle dialog opening for AuditPlayer
//   function handleDialog(audit) {
//     const isOpen = true;
//     setPlayer((plyr) => ({ ...AuditPlayer, isOpen, ...audit }));
//   }

//   // Load more audits when scrolling
//   const fetchMoreData = () => {
//     const newAudits = audits.slice(
//       displayAudits.length,
//       displayAudits.length + ITEMS_PER_PAGE
//     );

//     if (newAudits.length > 0) {
//       setDisplayAudits((prev) => [...prev, ...newAudits]);
//     } else {
//       setHasMore(false); // No more audits to load
//     }
//   };

//   return (
//     <InfiniteScroll
//       dataLength={displayAudits.length}
//       next={fetchMoreData}
//       hasMore={hasMore}
//       loader={<h4>Loading...</h4>}
//       style={{ width: '100%' }}
//     >
//       <Grid container spacing={1} {...other}>
//         <AuditPlayer
//           player={player}
//           setPlayer={setPlayer}
//           updateToClient={updateToClient}
//           isEscalating={isEscalating}
//           clientId={clientId}
//         />

//         {displayAudits.map((audit, idx) => (
//           <Grid key={idx} item xs={12} sm={6} md={4} lg={4}>
//             <AuditListCard audit={audit} handleDialog={handleDialog} />
//           </Grid>
//         ))}
//       </Grid>
//     </InfiniteScroll>
//   );
// }



import PropTypes from 'prop-types';
// material
import { Grid } from '@mui/material';
import AuditListCard from './AuditListCard';
import { AuditPlayer } from '../@dashboard/audit';
import { useMemo, useState } from 'react';

// ----------------------------------------------------------------------

AuditList.propTypes = {
  audits: PropTypes.array.isRequired,
  loadMoreAudits: PropTypes.func.isRequired, // Expect a function to fetch more audits
};

const getAuditEventKey = (audit, index) => {
  const eventKey = [
    audit?.EventNo,
    audit?.CameraId,
    audit?.EventTime,
    audit?.DetectedEventType,
    audit?.DetectedType,
    audit?.EventType,
    audit?.MainEventType,
  ].map((value) => String(value || '').trim()).filter(Boolean).join('|');

  return eventKey ? String(eventKey) : `audit-${index}`;
};

export default function AuditList({
  cameras,
  clientId,
  audits,
  loadMoreAudits,
  updateToClient,
  isEscalating,
  getCardsData,
  displayDialog,
  ...other
}) {
  const initValues = {
    src: null,
    isOpen: false,
  };
  const [, setPlayer] = useState(initValues);

  const auditsWithSnapshots = useMemo(() => {
    const cameraMap = (Array.isArray(cameras) ? cameras : []).reduce((acc, camera) => {
      if (camera.deviceid) {
        acc[camera.deviceid] = camera;
      }
      return acc;
    }, {});

    return (Array.isArray(audits) ? audits : []).map(audit => {
      if (audit.CameraId && cameraMap[audit.CameraId]) {
        return {
          ...audit,
          snapshot: cameraMap[audit.CameraId].snapshot
        };
      }
      return audit;
    });
  }, [audits, cameras]);

  // Function to handle dialog opening for AuditPlayer
  function handleDialog(audit) {
    console.log("selected audit details player",audit);
    const isOpen = true;
    displayDialog(isOpen,audit)
    setPlayer((plyr) => ({ ...AuditPlayer, isOpen, ...audit }));
  }

  function handleDialogFav(audit) {

    // const data = {
    //   EventNo: audit.EventNo,
    //   IsFavourite: audit.IsFavourite === 0 ? 1 : 0,        
    // }

    // postEventstatus( data,(response) =>{
    //   if(response.status === 200){
    //     console.log("updated Fav-event successfully...");
    //     getCardsData();
    //   }
    // })
  }

  return (
    <Grid container spacing={1} {...other}>
        {/* <AuditPlayer
          player={player}
          setPlayer={setPlayer}
          updateToClient={updateToClient}
          isEscalating={isEscalating}
          clientId={clientId}
        /> */}

        {/* {auditsWithSnapshots.map((audit, idx) => (
          <Grid key={idx} item xs={12} sm={6} md={4} lg={4} >
            <AuditListCard audit={audit} handleDialog={handleDialog} handleDialogFav={handleDialogFav}  />
          </Grid>
        ))} */}
{auditsWithSnapshots.map((audit, idx) => (
  <Grid key={`${getAuditEventKey(audit, idx)}-${idx}`} item xs={12} sm={6} md={4} lg={4} >
    <AuditListCard
      audit={audit}
      handleDialog={handleDialog}
      handleDialogFav={handleDialogFav}
      isUnviewed={audit.IsViewed === 0} // 👈 pass flag
    />
  </Grid>
))}



    </Grid>
  );
}
